<template>
  <div v-if="modelElement" class="bg-blue-100/30 p-4 rounded-lg relative space-y-4">
    <h3 v-text="toNormalCase(modelElement.type)" />

    <empty-container v-if="blogElementsWithTranslations.map((x)=>x.toLowerCase()).includes((modelElement.type as string).toLowerCase())">
      <ui-language-switcher-input
        v-model="modelElement.editing_language"
        v-model:show="modelElement.is_switching_language"
        :languages-checked="computedLanguagesSet"
        />
      <br>
    </empty-container>

    <slot/>

    <empty-container v-if="blogElementsWithCustomCss.map((x)=>x.toLowerCase()).includes((modelElement.type as string).toLowerCase())">
      <br>
      <ui-text
        v-model="modelElement.meta.custom_css"
        rows="5"
        label="Custom CSS"
        placeholder=".selector { &#10;&#x09;color:unique;&#10; }"
        :validation="(v,o,b) => {
          if (v && !(v+'')?.includes('.selector')){
            b('Custom CSS must contain at least one of: .selector')
          }
        }"
        @click="modelElement.meta.custom_css
          ? []
          : modelElement.meta.custom_css = '.selector { \n\t\n }'
        "
        />
    </empty-container>

    <ui-text
      v-model="modelElement.inside"
      label="Inside (CSS selector, like #footer)"
      />
  </div>
</template>

<script setup lang="ts">
const modelElement = defineModel<BlogElement>()

onBeforeUnmount(() => {
  if(!modelElement.value) return
  modelElement.value.is_switching_language = false
  delete modelElement.value.editing_language
})

const computedLanguagesSet = computed(() => {
  const keys = (Object.keys(modelElement.value?.meta?.i18n ?? {}) as SupportedLanguages[])
    .filter((key:SupportedLanguages) => modelElement.value?.meta?.i18n?.[key]?.content?.length)

  // push en if content is not empty
  if(keys.length && !keys.includes('en')) keys.push('en')

  return keys
})
</script>
